import React, { useEffect } from 'react';

const NativeBannerAd = () => {
    useEffect(() => {
        // Get the container
        const container = document.getElementById('container-7f1faf8030f8350bc347cbb8f59782db');
        if (!container) return;

        // Show the container
        container.style.display = 'block';

        return () => {
            // Hide the container when component unmounts
            if (container) {
                container.style.display = 'none';
                container.innerHTML = '';
            }
        };
    }, []);

    return (
        <div className="ad-container" style={{
            margin: '20px 0',
            minHeight: '250px',
            width: '100%',
            maxWidth: '728px',
            marginLeft: 'auto',
            marginRight: 'auto',
            backgroundColor: '#f8f9fa',
            borderRadius: '4px',
            overflow: 'hidden'
        }}>
            <div id="container-7f1faf8030f8350bc347cbb8f59782db" style={{ display: 'none' }}></div>
        </div>
    );
};

export default NativeBannerAd; 